(() => {
  if (window.__omGlobalProductCardsReady) return;
  window.__omGlobalProductCardsReady = true;

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-om-global-variant]');
    if (!select) return;
    const wrapper = select.closest('.card-wrapper');
    const price = wrapper?.querySelector('[data-om-global-price]');
    const option = select.options[select.selectedIndex];
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-om-global-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-om-global-add]');
    const status = form.querySelector('[data-om-global-status]');
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    if (status) status.textContent = '';
    try {
      const response = await fetch('/cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if (!response.ok) throw new Error('Unable to add');
      button.textContent = 'Added';
      if (status) status.textContent = 'Added to your cart.';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => { button.textContent = original; button.disabled = false; }, 1800);
    } catch (error) {
      button.textContent = original;
      button.disabled = false;
      if (status) status.textContent = 'Please try again or open the product page.';
    }
  });
})();